import appWindow from "./app-window";

const getLogoutMessage = () => {
  const logoutMessageKey = (appWindow() as any).STUDENT_ENV.REACT_APP_LOGOUT_MESSAGE_KEYNAME as string;
  const message = sessionStorage.getItem(logoutMessageKey);
  switch (message) {
    case "ForcedLogin":
      return "You have been logged out because you logged in elsewhere";
    case "IdleTimeout":
      return "You have been logged out because you have been inactive";
    case "UserLogoff":
      return "You have successfully logged out";
    case "UnathorizedUserLogoff":
      return "You are not authorized to access this application";
    default:
      return "You have been logged out";
  }
};

export default getLogoutMessage;
